<template>
  <div class="backup" @mouseup.stop="onOutUp()">
    <div class="labels" v-if="backup_name === '楼盘筛选套餐和标签'">
      <h2 class="normal">楼盘筛选套餐和标签</h2>
      <div class="normal">
        新建标签类别：<input type="text" v-model="newLabelType" placeholder="输入类别名称后回车" @keydown.enter="addNewLabelType">
      </div>
      <div class="type-box">
        <div class="type" v-for="(type,index) in backup_data" :key="'type' + index" 
          :style="{'background-color': type.show?'white':'#cccccc'}" @mouseup.stop="changeTypeOrder2(index)">
          <div class="type-name">
            <div>
              <span @mousedown.stop="changeTypeOrder1(index)">类别：</span>
              <input type="text" v-model="type.type">
              <button @click="hideType(index)">隐藏</button>
              <button @click="delType(index)">删除</button>
              <select v-model="type.mode">
                <option value="group">套餐</option>
                <option value="single">单独</option>
              </select>
            </div>
            <div class="normal">新建标签：<input type="text" v-model="type.newLabelName" placeholder="输入标签名称后回车"
                @keydown.enter="addNewLabel(index)"></div>
          </div>
          <div class="label-box">
            <div class="label" v-for="(label, iindex) in type.labels" :key="'label' + iindex"
              @mousedown.stop="changeLabelOrder1(index, iindex)" @mouseup.stop="changeLabelOrder2(index, iindex)"
              :style="{'background-color': label.show?'skyblue':'grey'}" @click="label.show = !label.show">
              <div @click.stop="type.labels.splice(iindex,1)" class="delLabel" @mousedown.stop="puts">删</div>
              <div @click.stop="type.labels[iindex].show = !type.labels[iindex].show" class="hideLabel"
                @mousedown.stop="puts">隐</div> 
              <span>{{label.name}}</span>
              <span>{{label.search_num}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="backup_name === '非无需摇号的楼盘'">
      <h2 class="normal">非无需摇号的楼盘</h2>
      <el-select v-model="idList" placeholder="请选择" :multiple="true" 
        size='mini' :filterable="true" default-first-option
      >
        <el-option v-for="item in realNameList" :key="item.id" :label="item.real_estate_name" :value="item.id">
        </el-option>
      </el-select>
    </div>

    <div class="other" v-else-if="backup_name === '干货海报底图'">
      <h2 class="normal">干货海报底图</h2>
      <div class="normal">
        <input type="file" @change="chooseImage" id="sunshine">
      </div>
      <div class="imageBox">
        <div v-for="(img,index) in images" :key="index" class="imageItem">
          <div class="normal">名称：<input type="text" v-model="img.title"></div>
          <img :src="img.img" preview="1">
          <button @click="delImage('images', index)">删除</button>
        </div>
      </div>
    </div>

    <div v-else-if="backup_name === '服务号领取干货回复'">
      <h2 class="normal">服务号领取干货回复</h2>
      <div class="normal">
        <el-button type="primary" @click="addReply">添加</el-button>
      </div>
      <div v-for="(item, index) in replyList" :key="index" style="margin-top: 40px;">
        <div class="normal" style="display:inline-block;">
          回复的内容：
          <el-input type="textarea" v-model="item.word" cols="40" rows="5" resize="none"
        style="font-size: 20px;" ></el-input>
        </div>
        <div class="normal">
          命中关键字：
          <el-select v-model="item.keys" multiple allow-create filterable default-first-option
            style="width: 400px;"
            placeholder="命中的关键字" size='mini'>
          </el-select>
        </div>
        <el-button type="primary" @click="setDefault(index)">{{item.default?'取消默认':'设为默认'}}</el-button>
        <el-button type="info" @click="delReply(index)">删除</el-button>
      </div>
    </div>
    <div v-else-if="backup_name === '关注小鸡选房自动回复'" class="normal">
      <h2 class="normal">关注小鸡选房自动回复</h2>
      <div class="normal" v-if="onReplyList.length > 0">
        <div>==========消息列表==========</div>
        <div v-for="(item,index) in onReplyList" :key="index" class="normal">
          <div v-if="item.type === 'text'">
            (文字消息)
            {{item.words}}
            <button @click="delReplyMsg(index)">删除</button>
          </div>
          <div v-if="item.type === 'mp'">
            (小程序链接)
            <el-image 
            style="width: 200px; height: 200px"
              :src="item.url" fit="contain"
              :preview-src-list="[item.url]">
            </el-image>
            <button @click="delReplyMsg(index)">删除</button>
          </div>
          <div v-if="item.type === 'image'">
            (图片消息)
            <el-image 
            style="width: 200px; height: 200px"
              :src="item.url" fit="contain"
              :preview-src-list="[item.url]">
            </el-image>
            <button @click="delReplyMsg(index)">删除</button>
          </div>
        </div>
      </div>
      <div class="normal">
        <el-button type="primary" @click="addReplyMsg('text')">添加文字</el-button>
        <el-button type="primary" @click="addReplyMsg('mp')">添加小程序</el-button>
        <el-button type="primary" @click="addReplyMsg('image')">添加图片</el-button>
      </div>
      <div class="normal">
        <div style="display:inline-block;">
          <el-input type="textarea" v-model="msgWords" placeholder="文字消息"
            cols="40" rows="5" resize="none" style="font-size: 18px;"
          ></el-input>
        </div>
      </div>
      <div class="normal">
        <div>==========图片素材==========</div>
        <div v-for="image in materialList" :key="image.media_id" style="display:inline-block;border:black 1px solid;position:relative">
          <el-image 
            style="width: 200px; height: 200px"
            :src="image.url" fit="contain"
            :preview-src-list="[image.url]">
          </el-image>
          <el-radio v-model="media_id" :label="image.media_id" style="position:absolute;left:10px;top:10px;z-index:999;background-color:#cccccc;">选择</el-radio>
        </div>
      </div>
    </div>

    <div v-else-if="backup_id === '1ne188ej8pl'" class="normal">
      排除的楼盘
      <el-select v-model="exEstates" filterable placeholder="选择楼盘" default-first-option
          :remote-method="searchEstate" remote multiple>
        <el-option v-for="(item,index) in matchEstates" :key="index" :label="item.real_estate_name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    
    <div class="other" v-else>
      <h2 class="normal">杂七杂八</h2>
      <div class="normal">名称：<input type="text" v-model="backup_name"></div>
      <div class="normal">数据：<textarea v-model="backup_data" cols="50" rows="10"></textarea></div>
      <div class="normal">
        <input type="file" @change="chooseImage">
      </div>
      <div>
        <img :src="imgSrc" alt="" preview="6">
      </div>
    </div>
    <button @click="upToDb" class="up">上传数据库</button>
    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        backup_id: '',
        backup_name: '',
        backup_data: '',
        imgSrc: '',
        newLabelType: '',
        draggingLabel: null,
        draggingType: null,

        idList: [], // 非无需摇号的楼盘
        realNameList: [],
        images: [],

        replyList: [], // 小鸡选房关键字回复
        onReplyList: [],  // 小鸡选房关注回复
        materialList: [],  // 小鸡选房素材列表
        media_id: '',
        msgWords: '',
        modelMap: {
          '杭州': 'WpBackupModel',
          '苏州': 'SzBackupModel',
          '天津': 'TjBackupModel',
          '绍兴': 'SxBackupModel',
          '宁波': 'NbBackupModel',
        },
        exEstates: [],
        matchEstates: [],
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {

      init() {
        let that = this
        let obj = that.$route.params
        console.log('obj', obj)
        if (obj.id) {
          if (obj.name === '楼盘副本') {
            return false;
          }
          that.$axios.get(that.$url_prefix + 'queryOneById', {
            params: {
              id: obj.id,
              db: that.modelMap[that.$store.state.Counter.city]
            }
          }).then(function (res) {
            console.log('query backup res', res)
            let resObj = res.data.data;
            that.backup_id = resObj.id
            that.backup_name = resObj.name
            if (resObj.name === '楼盘筛选套餐和标签') {
              that.backup_data = JSON.parse(resObj.data)
              console.log('data', that.backup_data)
            } else if (resObj.name === '非无需摇号的楼盘') {
              that.idList = JSON.parse(resObj.data)
              that.$axios.get(that.$url_prefix + 'queryRealEstateNameList').then(res => {
                that.realNameList = resObj;
              }).catch(err => {
                console.log('get realname list fail', err);
              })
            } else if (that.backup_name === '服务号领取干货回复') {
              if (resObj.data) {
                that.replyList = JSON.parse(resObj.data);
              }
            } else if (that.backup_name === '关注小鸡选房自动回复') {
              if (resObj.data) {
                that.onReplyList = JSON.parse(resObj.data);
              }
              that.$axios.get(that.$url_prefix + 'getMaterials').then(res => {
                that.materialList = res.data.data.item;
              }).catch(err => {
                console.log('getMaterials fail', err);
              })
            } else if (that.backup_name === '干货海报底图') {
              if (resObj.data) {
                that.images = JSON.parse(resObj.data);
              }
            } else if (that.backup_id === '1ne188ej8pl') { // 排除合作楼盘
              that.exEstates = JSON.parse(resObj.data);
              that.matchEstates = resObj.matchEstates || [];
            } else {
              that.backup_data = resObj.data
              if (resObj.data.indexOf('https') > -1) {
                that.imgSrc = resObj.data
              }
              try {
                console.log('data',JSON.parse(resObj.data));
              } catch (res) {
                console.log('parse fail');
              }
            }
            that.$nextTick(function () {
              that.$previewRefresh()
            })
          }).catch(function (res) {
            console.log('query backup fail', res)
          })

        }
      },

      //选择图片
      chooseImage(event) {
        let that = this
        let origin = event.target.id
        let option = {
          file: event.target.files[0],
          head_name: 'backup',
        }
        that.$uploadImage(option).then(function (res) {
          console.log('upload back', res)
          if (!res) {
            console.log('upload fail')
            return false;
          }
          let img_url = res
          that.imgSrc = img_url
          that.backup_data = img_url
          if (that.backup_name === '干货海报底图') {
            that.images.push({
              title: '',
              img: img_url
            })
          }
          that.$nextTick(function () {
            that.$previewRefresh()
          })
        }).catch(function (res) {
          console.log('upload fail', res)
        })
      },
     
      
      delImage(target, index) { // 删除其它图片
        if (typeof this.$data[target] === 'object') {
          this.$data[target].splice(index, 1)
        } else {
          this.$data[target] = ''
        }
      },

      //上传数据库
      upToDb() {
        let that = this
        let obj = {}

        if (that.backup_name.length === 0) {
          return false;
        }

        if (that.backup_id.length > 0) {
          obj.id = that.backup_id
        }
        if (that.backup_name === '楼盘筛选套餐和标签') {
          obj.data = JSON.stringify(that.backup_data)
        } else if (that.backup_name === '非无需摇号的楼盘') {
          obj.data = JSON.stringify(that.idList);
        } else if (that.backup_name === '干货海报底图') {
          obj.data = JSON.stringify(that.images);
        } else if (that.backup_name === '服务号领取干货回复') {
          obj.data = JSON.stringify(that.replyList);
        } else if (that.backup_name === '关注小鸡选房自动回复') {
          obj.data = JSON.stringify(that.onReplyList);
        } else if (that.backup_id === '1ne188ej8pl') { // 排除合作楼盘
          obj.data = JSON.stringify(that.exEstates);
        } else {
          obj.data = that.backup_data
        }

        obj.name = that.backup_name
        let param = {
          'db': that.modelMap[that.$store.state.Counter.city],
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('发送返回', res)
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('上传失败', res)
        })

      },

      addNewLabelType() {
        let str = this.newLabelType.replace(/\s/g, '')
        if (!str) {
          console.log('输入为空')
          return
        }
        // let result = this.backup_data.find(x => x.type === str)
        // if (result) {
        //   console.log('重复添加')
        //   return
        // }
        let obj = {
          type: str,
          labels: [],
          show: true
        }
        this.backup_data.push(obj)
        this.newLabelType = ''
      },
      addNewLabel(index) {
        let oneType = this.backup_data[index]
        let str = oneType.newLabelName.replace(/\s/g, '')
        if (!str) {
          console.log('输入为空')
          return
        }
        let result = oneType.labels.find(x => x.name === str)
        if (result) {
          console.log('重复添加')
          return
        }
        let obj = {
          name: str,
          show: true,
          search_num: 0
        }
        oneType.labels.push(obj)
        oneType.newLabelName = ''
      },
      hideType(index) {
        this.backup_data[index].show = !this.backup_data[index].show
      },
      delType(index) {
        this.backup_data.splice(index, 1)
      },

      changeLabelOrder1(index, iindex) {
        this.draggingLabel = {
          index: index,
          iindex: iindex,
          obj: this.backup_data[index].labels.splice(iindex, 1)[0]
        }
      },
      changeLabelOrder2(index, iindex) {
        if (this.draggingLabel) {
          this.backup_data[index].labels.splice(iindex, 0, this.draggingLabel.obj)
          this.draggingLabel = null
        }
        if (this.draggingType) {
          this.backup_data.splice(index, 0, this.draggingType.obj)
          this.draggingType = null
        }
      },
      changeTypeOrder1(index) {
        this.draggingType = {
          index: index,
          obj: this.backup_data.splice(index, 1)[0]
        }
      },
      changeTypeOrder2(index) {
        if (this.draggingType) {
          this.backup_data.splice(index, 0, this.draggingType.obj)
          this.draggingType = null
        }
      },
      onOutUp() {
        if (this.draggingLabel) {
          this.backup_data[this.draggingLabel.index].labels.splice(
            this.draggingLabel.iindex, 0, this.draggingLabel.obj)
          this.draggingLabel = null
        }
        if (this.draggingType) {
          this.backup_data.splice(this.draggingType.index, 0, this.draggingType.obj)
          this.draggingType = null
        }
      },
      puts() {
        console.log('阻止冒泡')
      },

      addReply() {
        this.replyList.push({
          word: '',
          keys: []
        })
      },
      delReply(index) {
        this.replyList.splice(index,1);
      },
      setDefault(index) {
        let temp = JSON.parse(JSON.stringify(this.replyList));
        let mo = temp[index].default;
        temp.forEach(x => delete x.default);
        if (!mo) {
          temp[index].default = true;
        }
        this.replyList = temp;
      },

      addReplyMsg(type) {
        if (type === 'text') {
          if (this.msgWords) {
            this.onReplyList.push({
              type: type,
              words: this.msgWords
            })
          } else {
            this.$message.error('请填写文字内容');
          }
        } else if (type === 'mp') {
          if (!this.media_id) {
            this.$message.error('请选择图片作为小程序封面');
            return;
          }
          if (!this.msgWords) {
            this.$message.error('请填写文字作为小程序标题');
            return;
          }
          let one = this.materialList.find(x => x.media_id === this.media_id);
          this.onReplyList.push({
            type: type,
            url: one.url,
            media_id: this.media_id,
            words: this.msgWords
          })
        } else if (type === 'image') {
          if (this.media_id) {
            let one = this.materialList.find(x => x.media_id === this.media_id);
            this.onReplyList.push({
              type: type,
              url: one.url,
              media_id: this.media_id
            })
          } else {
            this.$message.error('请选择图片');
          }
        }
      },
      delReplyMsg(index) {
        this.onReplyList.splice(index,1);
      },

      searchEstate(search) {
        let that = this;
        if (search) {
          that.$axios.get(that.$url_prefix + 'searchAllEstateName', {
            params: {
              search: search
            }
          }).then(res => {
            let list = res.data.data;
            let rest = that.matchEstates.filter(x => {
              return that.exEstates.includes(x.id);
            })
            list.forEach(x => {
              if (!that.exEstates.includes(x.id)) {
                rest.push(x);
              }
            })
            that.matchEstates = rest;
          })
        }
      },

    }
  }

</script>

<style scoped>
  .imageBox {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
  }

  .imageBox .imageItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
  }

  .backup {
    text-align: center;
    overflow: hidden;
  }

  .normal {
    margin: 10px 0;
  }

  .type-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    user-select: none;
  }

  .type {
    margin-top: 40px;
  }

  .label-box {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .label {
    height: 100px;
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    cursor: pointer;
    position: relative;
    margin-top: 5px;
  }

  .delLabel {
    position: absolute;
    top: 0;
    right: 0;
    height: 15px;
    width: 15px;
    background-color: wheat;
    padding: 3px;
  }

  .hideLabel {
    position: absolute;
    top: 0;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: beige;
    padding: 3px;
  }

  .up {
    margin-top: 20px;
    width: 150px;
    height: 50px;
    border-radius: 10px
  }

  img {
    height: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/page/backup.vue